import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const fm = (n, d = 2) => n.toLocaleString("da-DK", { minimumFractionDigits: d, maximumFractionDigits: d });
const dkJoin = (list) => (list.length > 1 ? list.slice(0, -1).join(", ") + " og " + list[list.length - 1] : list[0] || "");

export default function SpotPrice({ onUsePrice }) {
  const [area, setArea] = useState("DK1");
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");
  const [tillaeg, setTillaeg] = useState("1.40");

  useEffect(() => {
    let dead = false;
    setStatus("loading");
    fetch(`${API}/elpriser?area=${area}`)
      .then((r) => {
        if (!r.ok) throw new Error("fetch failed");
        return r.json();
      })
      .then((d) => {
        if (!dead) {
          setData(d);
          setStatus("ok");
        }
      })
      .catch(() => {
        if (!dead) setStatus("error");
      });
    return () => {
      dead = true;
    };
  }, [area]);

  const max = data ? Math.max(...data.timer.map((t) => t.kr_kwh), 0.0001) : 1;
  const till = parseFloat(tillaeg) || 0;
  const nuHour = String(new Date().getHours()).padStart(2, "0");
  const cheapest3 = data ? [...data.timer].sort((a, b) => a.kr_kwh - b.kr_kwh).slice(0, 3).map((t) => t.kl) : [];

  return (
    <div className="spot" data-testid="spot-price-panel">
      <div className="srow">
        <b>Aktuel spotpris i dag</b>
        <select aria-label="Prisområde" data-testid="spot-area-select" value={area} onChange={(e) => setArea(e.target.value)}>
          <option value="DK1">Vestdanmark (DK1)</option>
          <option value="DK2">Østdanmark (DK2)</option>
        </select>
      </div>
      {status === "loading" && <p className="smsg">Henter dagens priser …</p>}
      {status === "error" && (
        <p className="smsg" data-testid="spot-error">
          Kunne ikke hente dagens elpriser. Prøv igen senere, eller tast din pris manuelt ovenfor.
        </p>
      )}
      {status === "ok" && data && (
        <>
          <div className="bars" aria-hidden="true" data-testid="spot-bars">
            {data.timer.map((t) => (
              <span
                key={t.kl}
                className={"bar" + (t.kl === nuHour ? " now" : "") + (cheapest3.includes(t.kl) ? " cheap" : "")}
                style={{ height: Math.max(6, (t.kr_kwh / max) * 100) + "%" }}
                title={`kl. ${t.kl}: ${fm(t.kr_kwh)} kr./kWh`}
              />
            ))}
          </div>
          <div className="slbl">
            <span>00</span>
            <span>06</span>
            <span>12</span>
            <span>18</span>
            <span>23</span>
          </div>
          <p className="smsg">
            {data.nu && (
              <>
                Lige nu (kl. {data.nu.kl}):{" "}
                <b className="spris" data-testid="spot-current-price">
                  {fm(data.nu.kr_kwh)} kr./kWh
                </b>
                .{" "}
              </>
            )}
            <span data-testid="spot-cheapest-hours">Billigste timer i dag: kl. {dkJoin(cheapest3)}</span> – gode tidspunkter til vask og opladning.
          </p>
          <div className="srow">
            <label className="stillaeg">
              Tillæg (tariffer, afgifter, moms) kr./kWh
              <input
                data-testid="spot-surcharge-input"
                type="number"
                inputMode="decimal"
                min="0"
                step="0.05"
                value={tillaeg}
                onChange={(e) => setTillaeg(e.target.value)}
              />
            </label>
            {data.nu && (
              <button
                type="button"
                className="sbtn"
                data-testid="spot-use-price-button"
                onClick={() => onUsePrice((data.nu.kr_kwh + till).toFixed(2))}
              >
                Brug prisen lige nu: {fm(data.nu.kr_kwh + till)} kr.
              </button>
            )}
          </div>
          <p className="sfine">
            Spotpris fra Energinet ekskl. tillæg. Gul søjle er den aktuelle time, grønne er dagens 3 billigste timer.{" "}
            <a href="/elpriser/">Se alle dagens timepriser</a>
          </p>
        </>
      )}
    </div>
  );
}
